import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getEmployee360ReportData
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllActiveGroups', null)
    for (let item of Object.entries(response.data)) {
        groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    return groupArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return estateArray;
}


async function getEmployee360ReportData(data) {
    var model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        fromDate: data.fromDate,
        toDate: data.toDate,
        registrationNumber: data.regNumber,
        jobType: parseInt(data.employeeType),
    };
    const response = await CommonPost('/api/Employee360Report/GetEmployeeWise360ReportData', null, model);
    return response.data;
}

async function getDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetEveryDivisionsFromOperationEntitiyID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return divisionArray;
}